import React, {useEffect} from 'react'
import useContactForm from './hooks/useContactForm';

const Banner = () => {
    const { formData, handleChange, handleSubmit, isSuccess, isError, errorMessage, successMessage } = useContactForm()
    useEffect(() => {
    }, [successMessage]);
    return (
        <>
            <div className="banner">
                <div className="bnrform" data-aos="fade-left">
                    <p className='pb-8'>We are here to help you with your digital marketing needs. Fill out the form below and our team will get back to you shortly.</p>
                    {isError && <p className='text-red-800'>{errorMessage}</p>}
                    {isSuccess && <p className='text-blue-700'>{successMessage}</p>}
                    <form method="post" onSubmit={handleSubmit}>
                        <ul>
                            <li><input name="name" type="text" placeholder="Your Name*" value={formData.name} onChange={handleChange} /></li>
                            <li><input name="email" type="email" placeholder="Email Address*" value={formData.email} onChange={handleChange} /></li>
                            <li><input name="mobileNumber" type="number" value={formData.mobileNumber} placeholder="Phone Number*" onChange={handleChange} /></li>
                            <li><select name="service" value={formData.service} onChange={handleChange}>
                                <option value="">Select Service*</option>
                                <option value="Website Development">Website Design and Development</option>
                                <option value="Social Media Management">Social Media Management</option>
                                <option value="Facebook Ads">Facebook Ads</option>
                                <option value="Google Ads">Google Ads</option>
                                <option value="WhatsApp API Automation">WhatsApp API Automation</option>
                                <option value="Other">Others</option>
                            </select></li>
                            <li><textarea name="message" placeholder="Message*" value={formData.message} onChange={handleChange}></textarea></li>
                            <li><button type="submit" name="send" value="submit">Connect With Marketing Team</button></li>
                        </ul>
                    </form>
                </div>
            </div>
        </>
    )
}

export default Banner